const state = {
  subscriptions: [],
  cookieBar: true,
  token: '',
  refreshToken: null,
  tokenType: 0,
  userLevel: 0,
  partnerId: '',
  isValid: false,
  userName: '',
  userEnv: '',
  user: null,
  dutchStamps: [],
  userCredits: [],
  userSegments: [],
  userGroups: null,
  userType: 'u',
  tmpPartnerAdmin: false,
  userLanguage: {},
  partnerGroup: '',
  tmpUserId: '',
  tmpEmail: '',
  mainPartnerId: '',
  userRelationsAsChild: {},
  userRelationsAsParent: {},
  partnerGroupUserRelations: [],

  /**
   * Relations to partners, where the key is the partner id and the value contains
   * partner dependant data,e.g. CommState, DiscountPercentage, MaxBuyingOnAccountAmount
   */
  partnerUserRelations: {},
};

const mutations = {
  setCookieBar(state, cookieBar) {
    state.cookieBar = cookieBar;
  },
  setTmpEmail(state, tmpEmail) {
    state.tmpEmail = tmpEmail;
  },
  setMainPartnerId(state, mainPartnerId) {
    state.mainPartnerId = mainPartnerId;
  },
  setSubscriptions(state, subscription) {
    state.subscriptions = subscription;
  },
  setTmpUserId(state, tmpUserId) {
    state.tmpUserId = tmpUserId;
  },
  setUserLanguage(state, userLanguage) {
    state.userLanguage = userLanguage;
  },
  setUserType(state, userType) {
    state.userType = userType;
  },
  setUserName(state, userName) {
    state.userName = userName;
  },
  setUserEnv(state, accountId) {
    state.userEnv = accountId;
  },
  setUserLevel(state, userLevel) {
    state.userLevel = userLevel;
  },
  setPartnerId(state, partnerId) {
    state.partnerId = partnerId;
  },
  setTmpPartnerAdmin(state, tmpPartnerAdmin) {
    state.tmpPartnerAdmin = tmpPartnerAdmin;
  },
  setTokenType(state, tokenType) {
    state.tokenType = tokenType;
  },
  setRefreshToken(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  setToken(state, token) {
    state.token = token;

    if (token != null && token.trim() !== '') {
      state.isValid = true;
    } else {
      state.isValid = false;
    }
  },
  setStore(state, { token, isValid }) {
    state.token = token;
    state.isValid = isValid;
  },
  setUser(state, user) {
    state.user = user;
  },
  setDutchStamps(state, dutchStamps) {
    state.dutchStamps = dutchStamps;
  },
  setUserCredits(state, userCredits) {
    state.userCredits = userCredits;
  },
  setUserSegments(state, userSegments) {
    state.userSegments = userSegments;
  },
  logout(state) {
    state.token = '';
    state.isValid = false;
    state.tokenType = 0;
    state.userLevel = 0;
    state.partnerId = '';
    state.userName = '';
    state.user = null;
    state.userGroups = null;
    state.userType = 'u';
    state.userLanguage = {
      LanguageId: '14',
      LocalName: 'Nederlands',
      EnglishName: 'Dutch',
    };
    state.partnerUserRelations = {};
  },
  setUserGroups(state, userGroups) {
    state.userGroups = userGroups;
  },
  setPartnerGroup(state, partnerGroup) {
    state.partnerGroup = partnerGroup;
  },
  setPartnerUserRelations(state, relations) {
    state.partnerUserRelations = { ...relations };
  },
  setUserRelationsAsChild(state, relationsAsChild) {
    state.userRelationsAsChild = { ...relationsAsChild };
  },
  setUserRelationsAsParent(state, relationsAsParent) {
    state.userRelationsAsParent = { ...relationsAsParent };
  },
  setPartnerGroupUserRelations(state, partnerGroupUserRelations) {
    state.partnerGroupUserRelations = partnerGroupUserRelations;
  },
};

const getters = {
  cookieBar(state) {
    return state.cookieBar;
  },
  tmpEmail(state) {
    return state.tmpEmail;
  },
  mainPartnerId(state) {
    return state.mainPartnerId;
  },
  tmpUserId(state) {
    return state.tmpUserId;
  },
  userLanguage(state) {
    return state.userLanguage;
  },
  userType(state) {
    return state.userType;
  },

  userName(state) {
    return state.userName;
  },

  subscriptions(state) {
    return state.subscriptions;
  },

  isValid(state) {
    return state.isValid;
  },
  userEnv(state) {
    return state.userEnv;
  },
  userLevel(state) {
    return state.userLevel;
  },
  partnerId(state) {
    return state.partnerId;
  },
  tmpPartnerAdmin(state) {
    return state.tmpPartnerAdmin;
  },
  tokenType(state) {
    return state.tokenType;
  },

  user(state) {
    return state.user;
  },

  dutchStamps(state) {
    return state.dutchStamps;
  },

  userCredits(state) {
    return state.userCredits;
  },

  userSegments(state) {
    return state.userSegments;
  },

  token(state) {
    return state.token;
  },

  refreshToken(state) {
    return state.refreshToken;
  },

  userGroups(state) {
    return state.userGroups;
  },
  partnerGroup(state) {
    return state.partnerGroup;
  },
  userObjectId(state) {
    if (state.isValid) {
      return state.userName;
    }
    return state.tmpUserId;
  },
  partnerUserRelations(state) {
    return state.partnerUserRelations;
  },
  userRelationsAsChild(state) {
    return state.userRelationsAsChild;
  },
  userRelationsAsParent(state) {
    return state.userRelationsAsParent;
  },
  partnerGroupUserRelations(state) {
    return state.partnerGroupUserRelations;
  },
  buyByAccountPartiallyConfigured(state) {
    // True if MaxBuyingOnAccountAmount configured for parts of partners
    if (
      state.partnerUserRelations == null ||
      Object.keys(state.partnerUserRelations).length === 0
    ) {
      return false;
    }

    let oneConfigured = false;
    let allConfigured = true;
    // eslint-disable-next-line no-restricted-syntax
    for (const [, relation] of Object.entries(state.partnerUserRelations)) {
      const maxBuyingOnAccountAmount = relation.MaxBuyingOnAccountAmount;
      if (maxBuyingOnAccountAmount != null && maxBuyingOnAccountAmount > 0) {
        oneConfigured = true;
      } else {
        allConfigured = false;
      }
    }

    if (allConfigured || (!allConfigured && !oneConfigured)) {
      // Either all configured or none configured
      return false;
    }

    return true;
  },
  buyByAccountCompletelyConfigured(state) {
    // True if MaxBuyingOnAccountAmount configured for all partners
    if (
      state.partnerUserRelations == null ||
      Object.keys(state.partnerUserRelations).length === 0
    ) {
      return false;
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const [, relation] of Object.entries(state.partnerUserRelations)) {
      const maxBuyingOnAccountAmount = relation.MaxBuyingOnAccountAmount;
      if (maxBuyingOnAccountAmount == null || maxBuyingOnAccountAmount <= 0) {
        return false;
      }
    }

    return true;
  },
};

export const actions = {
  logout({ commit }) {
    commit('logout');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
